export default class SmsPhoneFields extends HTMLElement {
  connectedCallback () {
    this.country = this.querySelector('[data-sms-country]')
    if (!this.country) return

    this.country.addEventListener('focus', this.expandSelectedLabel)
    this.country.addEventListener('pointerdown', this.expandSelectedLabel)
    this.country.addEventListener('change', this.collapseSelectedLabel)
    this.country.addEventListener('blur', this.collapseSelectedLabel)
    this.collapseSelectedLabel()
  }

  disconnectedCallback () {
    this.country?.removeEventListener('focus', this.expandSelectedLabel)
    this.country?.removeEventListener('pointerdown', this.expandSelectedLabel)
    this.country?.removeEventListener('change', this.collapseSelectedLabel)
    this.country?.removeEventListener('blur', this.collapseSelectedLabel)
  }

  expandSelectedLabel = () => {
    this.country?.querySelectorAll('option[data-full-label]').forEach((option) => {
      option.textContent = option.dataset.fullLabel
    })
  }

  collapseSelectedLabel = () => {
    this.expandSelectedLabel()
    const option = this.country?.selectedOptions?.[0]
    if (option?.dataset.compactLabel) option.textContent = option.dataset.compactLabel
  }
}
